import Api from './Api';

const END_POINT = 'colors';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    store(color) {
        return Api.post(`${END_POINT}`, color);
    },
    update(color) {
        return Api.patch(`${END_POINT}/${color.id}`, color);
    },
    change_status(color) {
        return Api.patch(`${END_POINT}/${color.id}/change-status`, color);
    },
}